import * as React from "react"
import styled from "styled-components"
import { theme } from "../../theme"
import H0 from "../../atoms/typography/H0"
import { Col, Container, Hidden, Visible } from "react-grid-system"
import { HorizontalSpacer } from "../../atoms/spacers"
import H1 from "../../atoms/typography/H1"
import BodyLarge from "../../atoms/typography/BodyLarge"
import H4 from "../../atoms/typography/H4"
import { MediaQuery } from "../../../utils/design-helpers"
import H2 from "../../atoms/typography/H2"

interface Props {
  title: string
  imgSrc: string
  description: string
  slug: string
  imgAlt?: string
}

const BackgroundImage = styled.img`
  width: 100%;
  height: 100vh;
  object-fit: cover;
`

const AbsolutePosition = styled.div`
  position: absolute;
  top: 0;
  left: 64px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${MediaQuery.XS} {
    left: 0px;
  }
`

const CaseSlide: React.FunctionComponent<Props> = ({ title, imgSrc, description, slug, imgAlt }) => {
  return (
    <div style={{ position: "relative" }}>
      <BackgroundImage src={imgSrc} alt={imgAlt} />
      <AbsolutePosition>
        <Container>
          <Col md={10} xs={8}>
            <H2 color={theme.colors.white}>Scenario:</H2>
            <H1 bold={true} color={theme.colors.white}>
              {title}
            </H1>
          </Col>
          <HorizontalSpacer spacing={2} />
          <Col md={6} xs={9}>
            <BodyLarge color={theme.colors.white}>{description}</BodyLarge>
          </Col>
        </Container>
      </AbsolutePosition>
    </div>
  )
}

export default CaseSlide
